module.exports = __webpack_public_path__ + "img/SES_192142550.58ab677b.jpg";